import { TOPIC_GUIDES, type TopicGuide } from "./topic-guides";
import {
  CITIZENSHIP_ADDITIONAL_CHECKS,
  CITIZENSHIP_KEY_POINTS,
  CITIZENSHIP_SECTIONS,
} from "./topic-content-expansion-citizenship-sections";
import { CITIZENSHIP_FAQS } from "./topic-content-expansion-citizenship-faqs";

export const CITIZENSHIP_GUIDE = {
  topicId: "citizenship",
  locale: "ko",
  publicationStatus: "korean_test_preview",
  risk: "R4",
  checkedAt: "2026-07-16",
  jurisdictionLabel: "호주 전역·citizenship by conferral 일반 경로",
  summary:
    "호주 시민권을 준비할 때는 자신이 permanent resident 대상 conferral 경로인지 다른 pathway가 맞는지 먼저 확인하세요. 일반 residence requirement는 lawful·permanent residence와 해외 체류기간을 모두 보지만 exemptions·discretions와 New Zealand citizen 규칙이 적용될 수 있습니다. Residence Calculator는 guide일 뿐이므로 movement records와 visa history를 대조하고 identity·character 자료를 완전하게 제출하세요. 해당 신청자는 test 또는 interview를 거치며, approval 뒤 pledge가 필요한 사람은 ceremony를 완료해야 시민이 됩니다.",
  keyPoints: CITIZENSHIP_KEY_POINTS,
  sections: CITIZENSHIP_SECTIONS,
  faqs: CITIZENSHIP_FAQS,
  sourceIds: [
    "citizenship-source-conferral",
    "citizenship-source-residence",
    "citizenship-source-movement",
    "citizenship-source-test",
    "citizenship-source-common-bond",
    "citizenship-source-processing",
    "citizenship-source-ceremony",
  ],
  additionalChecks: CITIZENSHIP_ADDITIONAL_CHECKS,
  disclaimer:
    "이 콘텐츠는 Australian citizenship by conferral에 관한 R4 테스트 미리보기 생활정보이며 citizenship·migration·legal advice가 아닙니다. 개인의 pathway, residence, good character, test exemption, approval, processing time 또는 ceremony date를 확정하지 않습니다. 신청 전 Home Affairs의 current criteria와 residence assessment를 확인하고 복잡한 travel·SCV·criminal·migration history는 registered migration agent 또는 Australian legal practitioner에게 검토받으세요.",
} as const satisfies TopicGuide;

const target = TOPIC_GUIDES as unknown as TopicGuide[];
if (!target.some((guide) => guide.topicId === CITIZENSHIP_GUIDE.topicId)) {
  target.push(CITIZENSHIP_GUIDE);
}
